import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Table, Button } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const StaffSubjects = () => {
  const { staffId } = useParams();
  const navigate = useNavigate();
  const [staff, setStaff] = useState(null);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    fetchStaff();
    fetchSubjects();
  }, []);

  const getAuthToken = () => localStorage.getItem("authToken");

  const fetchStaff = async () => {
    const token = getAuthToken();
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}get-staff`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: staffId }),
      });
      const data = await response.json();
      if (response.ok) setStaff(data.data);
    } catch (error) {
      console.error("Failed to fetch staff details:", error);
    }
  };

  const fetchSubjects = async () => {
    const token = getAuthToken();
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}get-staff-subjects`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: staffId }),
      });
      const data = await response.json();
      if (response.ok) setSubjects(data.data);
    } catch (error) {
      console.error("Failed to fetch subjects:", error);
    }
  };

  const handleAssignSubject = async (subjectId) => {
    const token = getAuthToken();
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}add-subject-to-staff`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ staff_id: staffId, subject_id: subjectId }),
      });
      if (response.ok) {
        setSubjects((prevSubjects) =>
          prevSubjects.map((subject) =>
            subject.id === subjectId ? { ...subject, assigned: true } : subject
          )
        );
      }
    } catch (error) {
      console.error("Failed to assign subject:", error);
    }
  };

  const handleRemoveSubject = async (subjectId) => {
    const token = getAuthToken();
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}remove-subject-from-staff`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ staff_id: staffId, subject_id: subjectId }),
      });
      if (response.ok) {
        setSubjects((prevSubjects) =>
          prevSubjects.map((subject) =>
            subject.id === subjectId ? { ...subject, assigned: false } : subject
          )
        );
      }
    } catch (error) {
      console.error("Failed to remove subject:", error);
    }
  };

  return (
    <Layout>
      <h3>Manage Subjects for '{staff?.name}'</h3>
      <Button variant="secondary" onClick={() => navigate(-1)}>Go Back</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Subject Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {subjects.map((subject) => (
            <tr key={subject.id}>
              <td>{subject.name}</td>
              <td>
                {subject.assigned ? (
                  <Button variant="danger" size="sm" onClick={() => handleRemoveSubject(subject.id)}>
                    Remove
                  </Button>
                ) : (
                  <Button variant="success" size="sm" onClick={() => handleAssignSubject(subject.id)}>
                    Assign
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Layout>
  );
};

export default StaffSubjects;
